export default __webpack_public_path__ + "static/media/dff.c87a6387.svg";